<p-dialog
  [header]="titleKey | abpLocalization"
  [(visible)]="dialogVisible"
  [modal]="true"
  [style]="{ width: '32rem' }"
  [draggable]="false"
  [resizable]="false"
  [closable]="true"
  (onHide)="onHide()"
  styleClass="freeswitch-integration-form"
  contentStyleClass="freeswitch-integration-form__content">
  <form [formGroup]="form">
    <div class="freeswitch-integration-form__body">
      <div class="row g-3">
        <div class="col-12 col-md-6">
          <div class="freeswitch-integration-form__field">
            <label for="name" class="freeswitch-integration-form__label indicates-required-field">
              {{ 'FreeswitchIntegration::InstanceName' | abpLocalization }}
            </label>
            <input
              pInputText
              id="name"
              formControlName="name"
              maxlength="100"
              [placeholder]="'FreeswitchIntegration::InstanceNamePlaceholder' | abpLocalization"
              class="form-control w-full" />
          </div>
        </div>

        <div class="col-12 col-md-6">
          <div class="freeswitch-integration-form__field">
            <label for="ip" class="freeswitch-integration-form__label indicates-required-field">
              {{ 'FreeswitchIntegration::IpAddress' | abpLocalization }}
            </label>
            <input
              pInputText
              id="ip"
              formControlName="ipAddress"
              placeholder="192.168.1.1"
              class="form-control w-full" />
          </div>
        </div>

        <div class="col-12">
          <div class="freeswitch-integration-form__field">
            <label class="freeswitch-integration-form__label">
              {{ 'FreeswitchIntegration::AssignTenants' | abpLocalization }}
            </label>
            <p-multiselect
              [options]="tenantOptions"
              formControlName="assignedTenants"
              optionLabel="name"
              dataKey="tenantId"
              placeholder="{{ 'FreeswitchIntegration::SearchTenants' | abpLocalization }}"
              [filter]="true"
              [showClear]="true"
              appendTo="body"
              styleClass="w-full">
            </p-multiselect>
          </div>
        </div>

        <div class="col-12">
          <div class="freeswitch-integration-form__field">
            <label for="webRtcHost" class="freeswitch-integration-form__label">
              {{ 'FreeswitchIntegration::WebRtcHost' | abpLocalization }}
            </label>
            <input
              pInputText
              id="webRtcHost"
              formControlName="webRtcHost"
              [cxPendingLoader]="isValidating"
              maxlength="255"
              [placeholder]="'FreeswitchIntegration::WebRtcHostPlaceholder' | abpLocalization"
              class="form-control w-full" />
          </div>
        </div>

        <div class="col-12">
          <div class="freeswitch-integration-form__checkbox-row">
            <p-checkbox
              formControlName="isDefault"
              [binary]="true"
              inputId="isDefault">
            </p-checkbox>
            <div class="freeswitch-integration-form__checkbox-content">
              <label for="isDefault" class="freeswitch-integration-form__checkbox-label">
                <i
                  class="pi pi-star-fill freeswitch-integration-form__default-icon"
                  *ngIf="form.get('isDefault')?.value"></i>
                {{ 'FreeswitchIntegration::SetAsDefaultInstance' | abpLocalization }}
              </label>
              <small class="freeswitch-integration-form__hint">
                {{ 'FreeswitchIntegration::DefaultInstanceDescription' | abpLocalization }}
              </small>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>

  <ng-template #footer>
    <cx-form-actions
      layout="dialog"
      [cancelLabel]="'FreeswitchIntegration::Cancel' | abpLocalization"
      [saveLabel]="submitLabelKey | abpLocalization"
      saveType="button"
      [disabled]="form.invalid || isBusy"
      [isSubmitting]="isBusy"
      (cancel)="cancel()"
      (save)="onSave()">
    </cx-form-actions>
  </ng-template>
</p-dialog>
